/**
 * Created by olga on 11.01.2023
 */

const SpecialEnergyOfferIcon = function () {
    SideBarIcon.call(this, {
        extraBarIcon: bundles.extrabar && {
            json: bundles.extrabar.jsons.special_energy_offer_extrabar_icon,
            background: bundles.extrabar.frames.extrabar_icon_bg_green
        },
        skin: !cleverapps.meta.getSelectedLocation().locationConfig.isMain ? "expedition" : "normal",
        priority: SideBar.PRIORITY_REDUNDANT
    });

    this.available = true;
    this.resetState();
};

SpecialEnergyOfferIcon.prototype = Object.create(SideBarIcon.prototype);
SpecialEnergyOfferIcon.prototype.constructor = SpecialEnergyOfferIcon;

SpecialEnergyOfferIcon.prototype.resetState = function () {
    const leftTime = cleverapps.specialEnergyOffer.getIconLeftTime();
    if (leftTime <= 0) {
        cleverapps.extraBar.removeIcon(this);
    } else {
        this.setLeftTime(leftTime);
    }

    cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
};

SpecialEnergyOfferIcon.prototype.onPressed = function () {
    cleverapps.focusManager.display({
        focus: "SpecialEnergyOfferWindow",
        action: function (f) {
            new SpecialEnergyOfferWindow();
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};
